import { ColumnDef } from '@tanstack/react-table'
import DeleteMemberDialog from 'src/components/organisms/dialogs/DeleteMemberDialog'
import { formatDate } from 'src/enviroment/lib/formatters/format-date'
import { IMember } from 'src/types/user'
import RoleCell from './cell/RoleCell'
import EditMemberDialog from 'src/components/organisms/dialogs/EditMemberDialog'
import useAuth from 'src/enviroment/hooks/useAuth'

export type Member = IMember

export const useColumns = () => {
  const { user } = useAuth()

  const columns: ColumnDef<Member>[] = [
    {
      id: 'fullName',
      accessorFn: ({ firstName, lastName }) => `${firstName} ${lastName}`,
      header: 'Name',
      cell: ({
        row: {
          original: { firstName, lastName },
        },
      }) => (
        <span>
          {firstName} {lastName}
        </span>
      ),
      meta: { cellClassName: 'text-gray-50' },
    },
    {
      accessorKey: 'email',
      header: 'Email',
      meta: { cellClassName: 'text-gray-200' },
    },
    {
      accessorKey: 'company',
      header: 'Company',
      meta: { cellClassName: 'text-gray-200' },
    },
    {
      accessorKey: 'role',
      header: 'Role',
      cell: ({ row }) => <RoleCell member={row.original} />,
      meta: { cellClassName: 'text-gray-50' },
    },
    {
      accessorKey: 'lastLogin',
      header: 'Last Login',
      cell: ({ row }) => formatDate(row.original.lastLoginAt),
      meta: { cellClassName: 'text-gray-200' },
    },
    {
      id: 'actions',
      // header: () => (
      //   <div className="flex justify-center">
      //     <DeleteAllMembersDialog />
      //   </div>
      // ),
      cell: ({ row: { original } }) => {
        // Don't render action buttons if this is the current user
        if (user?.id === original.id) {
          return null
        }

        return (
          <div className="flex items-center gap-5 justify-self-center">
            <EditMemberDialog member={original} />
            <DeleteMemberDialog member={original} />
          </div>
        )
      },
    },
  ]

  return columns
}
